<template>
  <section class="contest-step2">
    <input
      type="file"
      class="upInput"
      accept=".mov, .flv, .mpg, .mpeg, .avi, .wmv, .asf, .rm, .rmvb, .mkv, .mp4"
      @change="upVideo"
    />
    <div class="upVideo" :class="{ containerSwcond: true }">
      <div class="progress-wrap">
        <div class="progress-head">
          <div class="videoupload">
            <b>{{ $t("global.视频上传") }}</b>
            {{ $t("global.支持格式") }}
            flv,mpg,mpeg,avi,wmv,mov,asf,rm,rmvb,mkv,mp4
            {{ $t("global.文件大小限制") }}，{{ $t("global.3G以内") }}
            <span class="resolving" v-if="matchId == 1027">{{
              $t("works.时长为1-5分钟，分辨率不小于1920*1080")
            }}</span>
            <button class="uploadVideo has" @click="getExistVideo">
              {{ $t("global.选择已发布的作品") }}
            </button>
          </div>
          <span class="uploadVideo" v-if="isFirst" @click="reUpload">{{
            $t("global.上传视频")
          }}</span>
          <div class="onloadings" v-if="!isFirst">
            <span class="videoed">
              <img src="/static/uploadvideo/videoed.png" />
            </span>
            <div class="left">{{ fileName }}</div>
            <div :class="{ right: true, hide: !isUploading }">
              {{ $t("global.正在上传") }}...
              <span ref="proNumber"></span>
            </div>
            <div class="right">{{ uploadMessage }}</div>
            <span class="reUpload" @click="reUpload">{{
              $t("global.重新上传")
            }}</span>

            <div class="progress">
              <div class="p-top" style="width: 0%" ref="progress"></div>
            </div>
          </div>
        </div>
        <div class="inputBox">
          <div class="titleInput">
            {{ $t("works.上传附件")
            }}<span>
            <span v-if="fileDesZh || fileDesEn">
              {{ language === 'zh' ? fileDesZh || fileDesEn : fileDesEn || fileDesZh }}
            </span>
            <span v-else>
              {{
                $t("works.可上传多个附件(压缩包、PDF等)，每个附件大小不超过100M")
              }}
            </span>  
            </span>
          </div>
          <div class="enclosure clearfix">
            <div
              class="sureList"
              v-for="(item, i) in attachments"
              :key="i"
            >
              {{ item.name }}
              <img
                src="/static/uploadvideo/img_x_del_icon@2x.png"
                alt=""
                @click="deleteSure(i)"
              />
            </div>
            <div class="uploadSure" @click="upload">{{ $t("works.上传") }}</div>
          </div>
        </div>
      </div>

      <div class="basic-wrap">
        <div class="alHead">{{ $t("global.基本信息") }}</div>
        <div class="contain containtitle editTitles">
          <div class="left">
            <div class="font">
              <em class="required">*</em>
              {{ $t("global.视频封面") }}
            </div>
          </div>
          <div class="right randomtopic">
            <span
              >{{ $t("global.格式") }}jpg、jpeg、png，{{
                $t("global.文件大小")
              }}≤3MB，{{ $t("global.图片比例") }}16:9，{{
                $t("global.尺寸")
              }}≥800*450</span
            >
            <div
              class="upload uploadwidth"
              :style="thumb | bgImageUrl('', 160, 90)"
              @click="reUploadF"
            >
              <div class="add-wrap" :class="{ 'add-wrap-active': thumb != '' }">
                <template v-if="thumb == ''"></template>
              </div>
              <div class="font">
                <span>{{ $t("global.上传封面") }}</span>
                <span></span>
              </div>
            </div>
            <div class="onrandom">
              <p class="defaults">{{ $t("global.系统默认可选封面") }}</p>
              <div class="dalayloading">
                <img src="/static/uploadvideo/loading.gif" v-if="!thumbs[0]" />
                <div
                  v-else
                  :style="thumbs[0] | bgImageUrl"
                  @click="thumb = thumbs[0]"
                  :class="{ active: thumb == thumbs[0] }"
                />
              </div>
              <div class="dalayloading">
                <img src="/static/uploadvideo/loading.gif" v-if="!thumbs[1]" />
                <div
                  v-else
                  :style="thumbs[1] | bgImageUrl"
                  @click="thumb = thumbs[1]"
                  :class="{ active: thumb == thumbs[1] }"
                />
              </div>
              <div class="dalayloading">
                <img src="/static/uploadvideo/loading.gif" v-if="!thumbs[2]" />
                <div
                  v-else
                  :style="thumbs[2] | bgImageUrl"
                  @click="thumb = thumbs[2]"
                  :class="{ active: thumb == thumbs[2] }"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="contain containtitle" id="view2">
          <div class="left">
            <div class="font">
              <em class="required">*</em>
              {{ $t("global.视频标题") }}
            </div>
          </div>
          <div class="right real-name">
            <input
              class="usertype"
              type="text"
              v-model="title"
              :maxlength="titleLength"
            />
            <span>
              <em>{{ getTitleLiength() }}</em
              >/40
            </span>
          </div>
        </div>
        <div class="contain containtitle editTitles" id="view3">
          <div class="left">
            <div class="font">
              <em class="required" v-if="matchProperty == 1">*</em>
              {{ $t("global.视频标题") }}({{ $t("global.英文") }})
            </div>
          </div>
          <div class="real-name right">
            <input
              class="usertype"
              type="text"
              v-model="enTitle"
              :maxlength="enTitleLength"
            />
            <span>
              <em>{{ getEnTitleLiength() }}</em
              >/40
            </span>
          </div>
        </div>
        <div class="contain containtitle" id="view4">
          <div class="left">
            <div class="font textLeft">
              <em class="required">*</em>
              {{ $t("global.视频简介") }}
              <span class="countNumber" v-if="matchId == 1027 && textTer">{{
                $t("works.50-500字")
              }}</span>
            </div>
          </div>
          <div class="textType">
            <span :class="{ active: textTer }" @click="textTer = true">{{
              $t("video.纯文字版")
            }}</span>
            <span :class="{ active: !textTer }" @click="textTer = false">{{
              $t("video.图文并茂版")
            }}</span>
          </div>
          <div v-if="textTer">
            <p class="zhText" v-if="language === 'zh'">
              <img
                v-if="introductionText"
                src="/static/uploadvideo/info_filled_tick@2x.png"
                alt
              />
              {{ $t("video.中文介绍") }}
            </p>
            <div class="real-name textareaname right">
              <textarea id="peopleDT" v-model="introductionText"></textarea>
            </div>
            <div v-if="language === 'zh'">
              <p class="enText">
                <img
                  v-if="enIntroductionText"
                  src="/static/uploadvideo/info_filled_tick@2x.png"
                  alt
                />
                {{
                  matchProperty == 1 && language === "zh"
                    ? $t("video.英文介绍")
                    : $t("video.英文介绍（选填）")
                }}
              </p>
              <div class="real-name textareaname right">
                <textarea id="peopleDT" v-model="enIntroductionText"></textarea>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="imageText">
              <div class="activeImageText" v-if="language === 'zh'">
                <span
                  :class="{ imageTextActive: textzh }"
                  @click="textzh = true"
                >
                  <img
                    v-if="introduction"
                    :src="
                      textzh
                        ? '/static/uploadvideo/info_filled_tick_active@2x.png'
                        : '/static/uploadvideo/info_filled_tick@2x.png'
                    "
                    alt
                  />
                  {{ $t("video.中文介绍") }}
                </span>
                <span
                  :class="{ imageTextActive: !textzh }"
                  @click="textzh = false"
                >
                  <img
                    v-if="enIntroduction"
                    :src="
                      !textzh
                        ? '/static/uploadvideo/info_filled_tick_active@2x.png'
                        : '/static/uploadvideo/info_filled_tick@2x.png'
                    "
                    alt
                  />
                  {{
                    matchProperty == 1 && language === "zh"
                      ? $t("video.英文介绍")
                      : $t("video.英文介绍（选填）")
                  }}
                </span>
              </div>
              <tinymc-editor
                v-if="textzh"
                class="editor"
                :content="introduction"
                @changeEdit="updateContent1"
                :height="height"
              />
              <tinymc-editor
                v-else
                class="editor"
                :content="enIntroduction"
                @changeEdit="updateContent2"
                :height="height"
              />
            </div>
          </div>
        </div>

        <div class="contain containtitle">
          <div class="left">
            <div class="font">
              <em class="required">*</em>
              {{ $t("global.类型") }}
            </div>
          </div>
          <div class="right female">
            <input
              type="radio"
              id="female"
              name="sex"
              :checked="isOriginal == '1'"
              @change="chagneOriginal('1')"
            />
            <label for="female">{{ $t("global.原创") }}</label>
            <input
              type="radio"
              id="male"
              name="sex"
              :checked="isOriginal == '2'"
              @change="chagneOriginal('2')"
            />
            <label for="male">{{ $t("global.非原创") }}</label>
          </div>
        </div>
        <div class="contain containtitle upload-wrap" id="view6">
          <div class="left">
            <div class="font">
              <em class="required">*</em>
              {{ $t("video.是否公开") }}
            </div>
          </div>
          <div class="right female">
            <input
              type="radio"
              id="female1"
              name="sex1"
              :checked="isPub == '0'"
              @change="chagneIsPub('0')"
            />
            <label for="female1">{{ $t("video.公开") }}</label>
            <input
              type="radio"
              id="male1"
              name="sex1"
              :checked="isPub == '1'"
              @change="chagneIsPub('1')"
            />
            <label for="male1">{{ $t("global.不公开") }}</label>
          </div>
        </div>
        <div class="contain containtitle upload-wrap" id="view5">
          <div class="left">
            <div class="font">
              <em class="required" v-if="imageCount">*</em>
              {{ $t("global.上传图片") }}
            </div>
          </div>
          <div class="right upcontent">
            <span>
              {{ $t("global.选填") }}，{{ $t("global.格式") }}jpg、jpeg、png，{{
                $t("global.文件大小")
              }}≤3MB，{{ $t("global.图片比例") }}16:9，{{
                $t("global.尺寸")
              }}≥800*450
              <br />
              <span v-if="imageCount">{{ $t("global.至少上传") }}
              <b>{{ imageCount || 0 }}</b>
              {{ $t("global.张作品") }}</span>
            </span>
            <div class="upcontent1">
              <div
                class="upload"
                v-for="(item, index) in images"
                :key="index"
                :style="item | bgImageUrl"
              >
                <img
                  @click="detaleImage(index)"
                  class="deteleImg"
                  src="/static/uploadvideo/img_x_del_icon@2x.png"
                  alt
                />
              </div>

              <div class="upload clickloads uploadwidth">
                <div class="add-wrap" @click="upImgClick(2)">
                  <img
                    src="/static/uploadvideo/staticicon.png"
                    alt
                    class="add"
                  />
                  <div class="font">
                    <span>{{ $t("global.上传图片") }}</span>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="contain containtitle editTitles">
          <div class="left">
            <div class="font">
              <em class="required">*</em>
              {{ $t("global.创作者") }}
            </div>
          </div>
          <div class="right">
            <span
              >{{ $t("global.上下拖拽可调整排序") }}
              <i v-if="matchId == 1027">{{ $t("works.最多添加10个") }}</i></span
            >
            <div class="otherCreaterStyle">
              <el-tree
                :props="treeProps"
                class="drap"
                empty-text
                :data="otherCreaterArr"
                node-key="id"
                draggable
                :allow-drop="allowDrop"
              ></el-tree>
              <div
                class="otherCitem"
                v-for="(item, index) in otherCreaterArr"
                :key="index"
              >
                <img
                  :src="
                    item.avatar
                      | imageUrl('/static/profile_img_default.png', 40, 40)
                  "
                  class="fanHead"
                />
                <span class="nickname">{{ item.nickname }}</span>
                <div class="roleBox">
                  <el-input
                    class="role"
                    :maxlength="item.max"
                    v-model="item.role"
                    :placeholder="`${$t('global.在作品中的角色')}，${$t(
                      'global.选填'
                    )}`"
                  ></el-input>
                  <span class="roleLen">{{ getLen(item, index) }}/8</span>
                </div>
                <el-input
                  v-if="matchId == 1027"
                  class="role"
                  v-model="item.name"
                  :placeholder="`${$t('global.真实姓名')}，${$t(
                    'global.选填'
                  )}`"
                ></el-input>
                <el-input
                  v-if="matchId == 1027"
                  class="role"
                  v-model="item.number"
                  :placeholder="`${$t('works.学号')}，${$t('global.选填')}`"
                ></el-input>
                <span
                  @click="deleteOtherCreater(index)"
                  v-if="!item.isUser"
                  class="deleteOC"
                  >{{ $t("global.删除") }}</span
                >
              </div>
            </div>
            <el-select
              v-model="chooseJoin.nickname"
              filterable
              remote
              :remote-method="searchUser"
              :placeholder="$t('global.选择共同创作者')"
              class="elselect"
            >
              <el-option
                v-for="(item, index) in fanlist"
                :key="index"
                :value="deteleHtml(item.nickname)"
              >
                <div @click="chooseJoin = item">
                  <img
                    :src="
                      item.avatar
                        | imageUrl('/static/profile_img_default.png', 40, 40)
                    "
                    class="step2-fanHead"
                  />
                  <i v-html="item.nickname"></i>
                </div>
              </el-option>
            </el-select>
            <el-button type="primary" @click="addCreater">{{
              $t("global.确定")
            }}</el-button>
          </div>
        </div>
      </div>
      <!-- 
      <div class="addLabel">
        <div class="alHead checkheadtitle">{{$t('global.选择标签')}}</div>

        <div class="contain editTitles containtitle">
          <div class="left">
            <p class="font">
              <em class="required">*</em>
              {{$t('global.行业')}}
            </p>
          </div>
          <div class="right">
            <span>{{$t('global.最多选择3个')}}</span>
            <div class="moretitle">
              <span
                v-for="(item ,index) in industryList"
                :key="index"
                @click="changeIndustryIds(item.categoryId)"
                :class="{active:isSelectOne(item.categoryId,industryIds)}"
              >{{item.title}}</span>
              <a class="clickaddtitle" @click="addIndustry = true">{{$t('global.新增')}}</a>
              <template v-if="addIndustry">
                <div class="userinfortit">
                  <input type="text" v-model="newIndustry" :placeholder="$t('global.输入标签')" />
                  <a @click="saveIndustry(1)">{{$t('global.确定')}}</a>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="contain editTitles containtitle">
          <div class="left">
            <p class="font">
              <em class="required">*</em>
              {{$t('global.专业')}}
            </p>
          </div>
          <div class="right">
            <span>{{$t('global.最多选择3个')}}</span>
            <div class="moretitle">
              <span
                v-for="(item ,index) in professionList"
                :key="index"
                @click="changeProfessionIds(item.categoryId)"
                :class="{active:isSelectOne(item.categoryId,professionIds)}"
              >{{item.title}}</span>
              <a class="clickaddtitle" @click="addProfession = true">{{$t('global.新增')}}</a>
              <template v-if="addProfession">
                <div class="userinfortit">
                  <input type="text" v-model="newProfession" :placeholder="$t('global.输入标签')" />
                  <a @click="saveIndustry(2)">{{$t('global.确定')}}</a>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="contain editTitles containtitle">
          <div class="left">
            <p class="font">{{$t('global.其他')}}</p>
          </div>
          <div class="right">
            <span>{{$t('global.选填')}}，{{$t('global.填写丰富的标签有助于增加作品的曝光')}}</span>
            <div class="moretitle">
              <span
                v-for="(item,index) in hotTagList"
                :key="index"
                @click="changeHotIds(item.title)"
                :class="{active:isSelectOne(item.title,hotIds)}"
              >{{item.title}}</span>
              <a class="clickaddtitle" @click="addHot = true">{{$t('global.新增')}}</a>
              <template v-if="addHot">
                <div class="userinfortit">
                  <input type="text" v-model="newHot" :placeholder="$t('global.输入标签')" />
                  <a @click="saveIndustry(3)">{{$t('global.确定')}}</a>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="contain editTitles containtitle">
          <div class="left">
            <p class="font">{{$t('global.制作软件')}}</p>
          </div>
          <div class="right">
            <span>{{$t('global.选填')}}，{{$t('global.填写丰富的标签有助于增加作品的曝光')}}</span>
            <div class="moretitle">
              <span
                v-for="(item,index) in equipment"
                @click="changeEquipmentIds(item.title)"
                :class="{active:isSelectOne(item.title,equipmentIds)}"
                :key="index"
              >{{item.title}}</span>
              <a class="clickaddtitle" @click="addEquipment = true">{{$t('global.新增')}}</a>
              <template v-if="addEquipment">
                <div class="userinfortit">
                  <input type="text" v-model="newEquipment" :placeholder="$t('global.输入标签')" />
                  <a @click="saveIndustry(4)">${{t('global.确定')}}</a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div> -->
      <div class="addLabel">
        <div class="alHead checkheadtitle">{{ $t("global.其他设置") }}</div>
        <div class="contain containtitle">
          <div class="left">
            <div class="font">
              <em class="required">*</em>
              {{ $t("global.免费下载") }}
            </div>
          </div>
          <div class="right female">
            <span>
              {{ $t("global.请仔细考虑是否愿意开放给所有") }}
              <b>MANA{{ $t("global.注册用户") }}</b>
              {{ $t("global.进行免费下载") }}，
              <br />
              {{ $t("global.下载的视频将会带有") }}
              <b>MANA logo{{ $t("global.水印") }}</b>
              {{ $t("global.和") }}
              <b>{{ $t("global.您的") }}MANA{{ $t("global.账号") }}</b
              >。
              <br />
              {{ $t("global.这将有利于您的作品在网络传播") }}，{{
                $t("global.被更多人看见")
              }}。
              <el-popover
                placement="right"
                width="400"
                trigger="click"
                @hide="$refs.watermark_sample.pause()"
              >
                <div class="watermark_sample">
                  <video
                    src="https://video.manamana.net/MANA_watermark_sample.m4v"
                    ref="watermark_sample"
                    controls
                  ></video>
                </div>
                <a
                  href="javascript:;"
                  slot="reference"
                  class="show_watermark_sample"
                  >{{ $t("global.查看示例") }}</a
                >
              </el-popover>
            </span>
            <input
              type="radio"
              id="noOpen"
              name="allowDownload"
              :checked="allowDownload === 2"
              @change="changeOpen(2)"
            />
            <label for="noOpen">{{ $t("global.不开放") }}</label>
            <input
              type="radio"
              id="open"
              name="allowDownload"
              :checked="allowDownload === 1"
              @change="changeOpen(1)"
            />
            <label for="open">{{ $t("global.开放") }}</label>
          </div>
        </div>
      </div>

      <input
        type="file"
        class="upInputIMG"
        accept="image/*"
        @change="upImg"
      />
      <input
        type="file"
        class="upInputIMG1"
        accept="image/*"
        @change="upImg1"
      />
      <input
        type="file"
        style="display: none"
        class="upInputSure"
        @change="upFile"
      />
      <cropImg
        ref="cropComponent"
        :dialog-width="900"
        :dialog-height="580"
        :crop-width="800"
        :crop-height="450"
        :min-width="800"
        :min-height="450"
        :fixed="fixed"
        :fixedNumber="fixedNumber"
        @update-img="updateImage"
        :is-upload="isUpload"
      ></cropImg>
    </div>
    <PerfectInformation
      @closeVisible="showChoose = false"
      @goToStep="chooseExistVideo"
      :matchId="matchId"
      v-if="showChoose"
    />
  </section>
</template>

<script type="text/ecmascript-6">
import service from "@/components/service.vue";
import PerfectInformation from "@/pages/dialog/PerfectInformation";
import * as qiniu from "qiniu-js";
import cropImg from "@/components/CropImg.vue";
import tinymcEditor from "@/components/editor/Editor";
import tools from "@/util/tools";

export default {
  name: "UpVideo",
  data() {
    return {
      attachments: [],
      fixed: true,
      fixedNumber: [16, 9],
      showChoose: false,
      isFirst: true,
      isIden: "",
      checkList: [],
      checkList1: [],
      fileName: "",
      checked: true,
      contentIndex: 1,
      selectedFilters: [],
      hotTagList: [],
      industryList: [],
      professionList: [],
      productLable: "",
      equipmentLable: "",
      fanlist: [],
      title: "",
      enTitle: "",
      titleLength: null,
      enTitleLength: null,
      hash: "",
      key: "",
      thumb: "",
      images: [],
      introduction: "",
      enIntroduction: "",
      introductionText: "",
      enIntroductionText: "",
      videoBusinessDomain: {},
      videoTagFrontForms: [],
      isOriginal: "2",
      allowDownload: 2,
      activityId: "",
      industryIds: [],
      professionIds: [],
      creatorIds: [],
      chooseNmae: "",
      otherCreaterArr: [],
      search: "",
      token: "",
      sendFlag: true,
      submitFlag: true,
      videoId: undefined,
      //$t('global.当前用户')
      user: {},
      addIndustry: false,
      newIndustry: "",
      addProfession: false,
      newProfession: "",

      phone: "",
      code: "",
      thumbs: [],
      //hot$t('global.标签')
      hotIds: [],
      otherHotIds: [],
      newHot: "",
      addHot: false,
      equipment: [],
      newEquipment: "",
      addEquipment: false,
      equipmentIds: [],
      otherEquimentIds: [],
      isActive0: false,
      isActive1: false,
      isActive2: false,
      isUpload: false,
      isUploading: false,
      uploadMessage: "",
      treeProps: {
        label: (data) => "",
      },
      chooseJoin: {},
      showDialog: false,
      cancelObj: {},
      textTer: true,
      textzh: true,
      isPub: null,
      videoWidth: null,
      videoHeight: null,
    };
  },
  components: {
    service,
    cropImg,
    PerfectInformation,
    tinymcEditor,
  },
  props: ["matchProperty", "matchId", "callback", "imageCount", "fileDesZh", "fileDesEn"],
  computed: {
    getProgress() {
      return this.progress;
    },
    language() {
      return this.$language();
    },
  },
  created() {
    this.init();
  },
  watch: {
    "$store.state.accountUser"(val) {
      this.user = val;
    },
    fileName(val) {
      if (this.title) {
      } else {
        this.title = val.split(".")[0];
      }
    },
    isOriginal(val) {
      if (val == "1") {
        this.isOriginal = "1";
      } else {
        this.isOriginal = "2";
      }
    },
    professionIds(value) {
      if (value && value.length > 3) {
        this.$message(`${this.$t("global.专业最多只能选")}3个`);
        this.professionIds.splice(value.length - 1, 1);
      }
    },
    industryIds() {
      if (this.industryIds.length > 3) {
        this.$message(`${this.$t("global.行业最多只能选")}3个`);
        this.industryIds.splice(this.industryIds.length - 1, 1);
      }
    },
    titleLength(val) {
      if (val > 80) {
        this.title = this.title.substring(0, 40);
        return;
      }
    },
    enTitleLength(val) {
      if (val > 80) {
        this.enTitle = this.enTitle.substring(0, 40);
        return;
      }
    },
  },
  methods: {
    deleteSure(index) {
      this.attachments = this.attachments.filter(
        (item, i) => {
          return i != index;
        }
      );
      localStorage.setItem("attachments", JSON.stringify(this.attachments));
    },
    upload() {
      document.querySelector(".upInputSure").value = "";
      document.querySelector(".upInputSure").click();
    },
    upFile(e) {
      var $this = this;
      var fileName = e.target.files[0].name;
      const type = e.target.files[0].type;
      // const list =
      //   "video/quicktime,video/x-flv,video/mpg,video/mpeg,video/x-msvideo,video/x-ms-wmv,video/x-ms-asf,	application/vnd.rn-realmedia,video/rmvb,video/mkv,video/mp4".split(
      //     ","
      //   );
      // if (!list.includes(type)) {
      //   this.$message.info(`${$this.$t("global.上传失败")},${this.$t(
      //     "global.请检查上传格式是否符合支持格式"
      //   )}`);
      //   return;
      // }
      if (e.target.files[0].size / 1024 / 1024 > 100) {
        this.$message.info(this.$t("works.文件不能大于100M"));
        return;
      }
      this.$message({
        duration: 0,
        iconClass: 'icon-loading',
        customClass: 'fileUpload',
        offset: 300
      })
      var observable;
      var subscription;
      var error = function(err) {
        $this.$message.closeAll();
        $this.$message.error($this.$t("global.上传失败"));
      };

      var complete = function(res) {
        $this.attachments.push({
          name: e.target.files[0].name,
          key: res.key
        });
        $this.$message.closeAll();
        localStorage.setItem("attachments", JSON.stringify($this.attachments));
      };

      var next = function(response) {};
      var subObject = {
        next: next,
        error: error,
        complete: complete
      };

      var config = {
        useCdnDomain: true,
        disableStatisticsReport: false,
        retryCount: 3,
        region: null
      };
      var putExtra = {
        fname: fileName.split(".")[0],
        params: {},
        mimeType: null
      };
      this.$http.get("/api/common/upload/token/video").then(res => {
        this.token = res.data;
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          this.token,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    reset() {
      this.selectedFilters = "";
      this.creatorIds = [];
      this.title = "";
      this.introduction = "";
      this.thumb = "";
      this.images = [];
      this.allowDownload = 2;
      this.isOriginal = "2";
      this.equipment = [];
      this.hash = "";
      this.activityId = "";
      this.industryIds = [];
      this.professionIds = [];
      this.key = "";
      this.fileName = "";
      this.isUpload = false;
    },
    init() {
      this.reset();
      const videoId = this.$query.videoId;
      if (videoId) {
        this.detail(videoId);
        this.videoId = videoId;
      }
      this.user = this.$store.state.accountUser;
      if (this.matchId == 1027) {
        this.otherCreaterArr = [
          {
            creatorId: this.user.userId,
            avatar: this.user.avatar,
            nickname: this.user.nickname,
            isUser: true,
            role: "",
            name: "",
            number: "",
          },
        ];
      } else {
        this.otherCreaterArr = [
          {
            creatorId: this.user.userId,
            avatar: this.user.avatar,
            nickname: this.user.nickname,
            isUser: true,
            role: "",
          },
        ];
      }
      this.hotTagListF();
      this.categoryList();
      this.getOtherCreator();
      this.getEquipmentList();
    },
    chooseExistVideo(id) {
      this.videoId = id;
      this.detail(id);
      this.showChoose = false;
    },
    getExistVideo() {
      this.showChoose = true;
    },
    changeOpen(num) {
      this.allowDownload = num;
    },
    handleClose() {
      this.isOriginal = "2";
    },
    changeEdit(content) {
      this.tinymceHtml = content;
    },
    addCreater() {
      if (this.matchId == 1027) {
        if (this.otherCreaterArr.length >= 10) {
          this.$message.error(this.$t("works.最多添加10个"));
          return;
        }
      }
      const hasCreater = this.otherCreaterArr.filter(
        (item) => item.creatorId === this.chooseJoin.creatorId
      );
      if (this.chooseJoin && this.chooseJoin.nickname && !hasCreater.length) {
        if (this.matchId == 1027) {
          this.otherCreaterArr.push({
            ...this.chooseJoin,
            role: "",
            isUser: this.user.userId === this.chooseJoin.creatorId,
            name: "",
            number: "",
          });
        } else {
          this.otherCreaterArr.push({
            ...this.chooseJoin,
            role: "",
            isUser: this.user.userId === this.chooseJoin.creatorId,
          });
        }
        this.chooseJoin = {};
      } else if (hasCreater.length) {
        this.$message.error(this.$t("global.共同创作者已存在"));
        this.chooseJoin = {};
      }
    },
    allowDrop(draggingNode, dropNode, type) {
      return type !== "inner";
    },
    getTitleLiength() {
      const reg = /[^\x00-\xff]/g;
      let len = this.title && this.title.length;
      if (reg.test(this.title)) {
        len += this.title.match(reg) && this.title.match(reg).length;
      }
      const roleLen = Math.ceil(len / 2);
      if (roleLen >= 40) {
        this.titleLength = len;
      }
      return roleLen || 0;
    },
    getEnTitleLiength() {
      const reg = /[^\x00-\xff]/g;
      let len = this.enTitle && this.enTitle.length;
      if (reg.test(this.enTitle)) {
        len += this.enTitle.match(reg) && this.enTitle.match(reg).length;
      }
      const roleLen = Math.ceil(len / 2);
      if (roleLen >= 40) {
        this.enTitleLength = len;
      }
      return roleLen || 0;
    },
    getLen(item, index) {
      const reg = /[^\x00-\xff]/g;

      let len = item.role && item.role.length;
      if (reg.test(item.role)) {
        len += item.role.match(reg) && item.role.match(reg).length;
      }
      const roleLen = Math.ceil(len / 2);
      if (roleLen >= 8) {
        item.max = len;
      }
      return roleLen || 0;
    },
    reUploadF() {
      this.$refs.cropComponent.reUpload("3size");
    },
    updateImage(img) {
      this.thumb = img.data;
      let imgFile = this.$jsonUtils.base64ToFile(this.thumb, "a.png");
      //上传截取图片
      // if (imgFile.size / 1024 / 1024 > 3) {
      //   this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
      //   return;
      // }
      let $this = this;
      var observable;
      var subscription;
      var error = function (err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function (res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        $this.thumb = res.key;
      };

      var next = function (response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true,
      };
      var putExtra = {
        fname: imgFile.name,
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/image/token").then((res) => {
        observable = qiniu.upload(
          imgFile,
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
      // let param = new FormData();
      // param.append("files", imgFile);
      // param.append("fileNames", "thumb");
      // /*   param.append("deleteNames",this.thumb.bannerUrl);*/

      // this.$http
      //   .post("/api/common/upload/images", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then((response) => {
      //     this.$message({
      //       message: response.message,
      //       type: "success",
      //     });
      //     this.thumb = response.data.thumb.key;
      //   });
    },
    reUpload() {
      if(!this.videoId){
        document.querySelector(".upInput").click();
      } else {
        this.$router.push('/UpVideo?edit=true&videoId='+this.videoId);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    removeFormat(name) {
      let val = name.lastIndexOf(".");
      if (val != -1) {
        return name.substr(0, val);
      } else {
        return name;
      }
    },

    saveIndustry(type) {
      let url = "/api/other/createTag";
      let form = {};
      let $this = this;
      form["type"] = type;
      switch (type) {
        case 1:
          form["name"] = this.newIndustry;
          if (this.newIndustry == "") {
            this.$message(this.$t("global.新增行业不能为空"));
            return;
          }
          break;
        case 2:
          form["name"] = this.newProfession;
          if (this.newProfession == "") {
            this.$message(this.$t("global.新增专业不能为空"));
            return;
          }
          break;
        case 3:
          form["name"] = this.newHot;
          if (this.newHot == "") {
            this.$message(this.$t("global.新增其他标签不能为空"));
            return;
          }
          break;
        case 4:
          form["name"] = this.newEquipment;
          if (this.newEquipment == "") {
            this.$message(this.$t("global.新增工作设置不能为空"));
            return;
          }
          break;
      }
      this.$http.post(url, form).then((response) => {
        if (response.code == "OK") {
          let tagD = response.data;
          let newTag = {};
          if (tagD != null) {
            newTag["title"] = tagD.title;
            newTag["type"] = "other";
            newTag["categoryId"] = tagD.id + "_other";
            if (type == 1) {
              if (
                $this.$jsonUtils.findRowByColAndVal(
                  $this.industryList,
                  "title",
                  tagD.title
                ) == null
              ) {
                $this.industryList.push(newTag);
                $this.industryIds.push(newTag.categoryId);
                $this.newIndustry = "";
                $this.addIndustry = false;
              }
            } else if (type == 2) {
              if (
                $this.$jsonUtils.findRowByColAndVal(
                  $this.professionList,
                  "title",
                  tagD.title
                ) == null
              ) {
                $this.professionList.push(newTag);
                $this.professionIds.push(newTag.categoryId);
                $this.newProfession = "";
                $this.addProfession = false;
              }
            } else if (type == 3) {
              if (
                $this.$jsonUtils.findRowByColAndVal(
                  $this.hotTagList,
                  "title",
                  tagD.title
                ) == null
              ) {
                $this.hotTagList.push(newTag);
                $this.hotIds.push(newTag.title);
                $this.newHot = "";
                $this.addHot = false;
              }
            } else if (type == 4) {
              if (
                $this.$jsonUtils.findRowByColAndVal(
                  $this.equipment,
                  "title",
                  tagD.title
                ) == null
              ) {
                $this.equipment.push(newTag);
                $this.equipmentIds.push(newTag.title);
                $this.newEquipment = "";
                $this.addEquipment = false;
              }
            }
          }
        }
      });
    },
    changeEquipmentIds(id) {
      let index = this.equipmentIds.indexOf(id);
      if (index == -1) {
        this.equipmentIds.push(id);
      } else {
        this.equipmentIds.splice(index, 1);
      }
    },
    changeCategoryIds(id) {
      this.matchCategoryIds.splice(0, 1, id);
      this.categoryId = id;
    },
    changeHotIds(id) {
      let index = this.hotIds.indexOf(id);
      if (index == -1) {
        this.hotIds.push(id);
      } else {
        this.hotIds.splice(index, 1);
      }
    },
    changeIndustryIds(id) {
      let index = this.industryIds.indexOf(id);
      if (index == -1) {
        this.industryIds.push(id);
      } else {
        this.industryIds.splice(index, 1);
      }
    },
    changeProfessionIds(id) {
      let index = this.professionIds.indexOf(id);
      if (index == -1) {
        this.professionIds.push(id);
      } else {
        this.professionIds.splice(index, 1);
      }
    },
    isSelectOne(item, list) {
      let index = list.indexOf(item);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    isSelect(item) {
      let index = this.equipmentIds.indexOf(item);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    searchUser(query) {
      if (query !== "") {
        this.get_searchUser(query);
      } else {
        this.fanlist = [];
      }
    },
    detaleImage(index) {
      this.images = this.images.filter((item, i) => {
        return i != index;
      });
    },
    deteleHtml(html) {
      let reg = /(<\/?em.*?>)/gi;
      return html.replace(reg, "");
    },
    get_searchUser(query) {
      const _this = this;
      const params = {
        isCertification: undefined,
        keyword: query || undefined,
        initial: undefined,
        city: undefined,
        type: 2,
        pageIndex: 1,
        pageSize: 50,
      };
      this.$http
        .post("/api/search/list2", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          if (
            response.data &&
            response.data.pageList &&
            response.data.pageList.list
          ) {
            const userList = filter_user(response.data.pageList.list);
            _this.fanlist = userList;
          }
        });
      function filter_user(list) {
        let userList = [];
        for (let i = 0; i < list.length; i++) {
          const el = list[i];
          const userDetail = {
            avatar: el.avatar,
            creatorId: el.userId,
            nickname: el.nickname,
          };
          userList.push(userDetail);
        }
        return userList;
      }
    },
    initFile() {
      this.title = "";
      this.thumbs = [];
      this.fileName = "";
      this.isUpload = false;
      this.isUploading = false;
    },
    hotTagListF() {
      this.$http.get("/api/common/hotTagList").then((response) => {
        this.hotTagList = response.data;
      });
    },
    getEquipmentList() {
      this.$http
        .get("/api/other/tagListOrTag", { params: { type: 5 } })
        .then((response) => {
          this.equipment = response.data;
        });
    },
    categoryList() {
      this.$http.get("/api/common/categoryList").then((response) => {
        this.industryList = response.data.industryList;
        this.professionList = response.data.professionList;
      });
    },
    changeIndex(index) {
      this.contentIndex = index;
    },
    gotoContent() {
      document.querySelector(".upInput").click();
    },
    upImgClick(index) {
      this.$store.dispatch("setImgIndex", index);
      if (index === 1) {
        document.querySelector(".upInputIMG").click();
      } else {
        document.querySelector(".upInputIMG1").value = "";
        document.querySelector(".upInputIMG1").click();
      }
    },
    chagneOriginal(val) {
      this.isOriginal = val;
    },
    chagneIsPub(val) {
      this.isPub = val;
    },
    updateContent1(content) {
      this.introduction = content;
    },
    updateContent2(content) {
      this.enIntroduction = content;
    },
    deleteOtherCreater(index) {
      this.otherCreaterArr.splice(index, 1);
    },
    upVideo(e) {
      var $this = this;
      this.initFile();
      this.fileName = e.target.files[0].name;
      this.isFirst = false;
      const type = e.target.files[0].type;
      if (this.matchId == 1027) {
        let videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(e.target.files[0]);
        videoElement.addEventListener("loadedmetadata", function () {
          $this.videoWidth = videoElement.videoWidth;
          $this.videoHeight = videoElement.videoHeight;
          if (
            videoElement.duration / 60 < 1 ||
            videoElement.duration / 60 > 5
          ) {
            $this.$message.error("时长为1-5分钟！");
            return;
          }
          if (
            videoElement.videoWidth < 1920 ||
            videoElement.videoHeight < 1080
          ) {
            $this.$message.error("分辨率不小于1920*1080！");
            return;
          }
          if (!tools.supportedVideoFormat(type)) {
            $this.uploadMessage = `${$this.$t("global.上传失败")},${this.$t(
              "global.请检查上传格式是否符合支持格式"
            )}`;
            return;
          }
          $this.isUploading = true;
          if (e.target.files[0].size / 1024 / 1024 > 3072) {
            $this.$message.info($this.$t("global.文件不能大于3G"));
            return;
          }
          // this.isUpload = true;

          var observable;
          var subscription;
          var error = function (err) {
            $this.uploadMessage = $this.$t("global.上传失败");
          };

          var complete = function (res) {
            $this.isUploading = false;
            $this.uploadMessage = $this.$t("global.上传成功");
            $this.hash = res.hash;
            $this.key = res.key;
            let videoUrl = `/api/common/getVideoDuration`;
            $this.$http
              .get(videoUrl, { params: { fileName: res.key } })
              .then((response) => {
                var videoData = response;
                if (videoData.data != null && videoData.data != "") {
                  let duration = videoData.data;
                  $this.thumbs = [];
                  let time1 = $this.$jsonUtils.RandomNum(2, Number(duration));
                  let time2 = $this.$jsonUtils.RandomNum(2, Number(duration));
                  $this.thumbs[1] = `https://video.manamana.net/${res.key}?vframe/jpg/offset/${time1}/w/800/h/450`;
                  $this.thumbs[2] = `https://video.manamana.net/${res.key}?vframe/jpg/offset/${time2}/w/800/h/450`;
                  let thumb = `https://video.manamana.net/${$this.key}?vframe/jpg/offset/1/w/800/h/450`;
                  if ($this.thumb == "") {
                    $this.thumb = thumb;
                  }
                  $this.thumbs[0] = thumb;
                }
              });
          };

          var next = function (response) {
            var total = response.total;
            $this.$refs.progress.style.width = parseInt(total.percent) + "%";
            $this.$refs.proNumber.innerHTML = `${$this.$t("global.已上传")}${
              Math.round(total.percent * 100) / 100
            }%`;
          };

          var subObject = {
            next: next,
            error: error,
            complete: complete,
          };

          var config = {
            useCdnDomain: true,
            disableStatisticsReport: false,
            retryCount: 3,
            region: null,
          };
          var putExtra = {
            fname: $this.fileName.split(".")[0],
            params: {},
            mimeType: null,
          };
          $this.$http.get("/api/common/upload/token/video").then((res) => {
            $this.token = res.data;
            observable = qiniu.upload(
              e.target.files[0],
              Date.parse(new Date()) + "_" + $this.$jsonUtils.randomLetter(8),
              $this.token,
              putExtra,
              config
            );
            subscription = observable.subscribe(subObject);
          });
        });
      } else {
        let videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(e.target.files[0]);
        videoElement.addEventListener("loadedmetadata", function () {
          $this.videoWidth = videoElement.videoWidth;
          $this.videoHeight = videoElement.videoHeight;
        })
        if (!tools.supportedVideoFormat(type)) {
          this.uploadMessage = `${$this.$t("global.上传失败")},${this.$t(
            "global.请检查上传格式是否符合支持格式"
          )}`;
          return;
        }
        this.isUploading = true;
        if (e.target.files[0].size / 1024 / 1024 > 3072) {
          this.$message.info(this.$t("global.文件不能大于3G"));
          return;
        }
        // this.isUpload = true;

        var observable;
        var subscription;
        var error = function (err) {
          $this.uploadMessage = $this.$t("global.上传失败");
        };

        var complete = function (res) {
          $this.isUploading = false;
          $this.uploadMessage = $this.$t("global.上传成功");
          $this.hash = res.hash;
          $this.key = res.key;
          let videoUrl = `/api/common/getVideoDuration`;
          $this.$http
            .get(videoUrl, { params: { fileName: res.key } })
            .then((response) => {
              var videoData = response;
              if (videoData.data != null && videoData.data != "") {
                let duration = videoData.data;
                $this.thumbs = [];
                let time1 = $this.$jsonUtils.RandomNum(2, Number(duration));
                let time2 = $this.$jsonUtils.RandomNum(2, Number(duration));
                $this.thumbs[1] = `https://video.manamana.net/${res.key}?vframe/jpg/offset/${time1}/w/800/h/450`;
                $this.thumbs[2] = `https://video.manamana.net/${res.key}?vframe/jpg/offset/${time2}/w/800/h/450`;
                let thumb = `https://video.manamana.net/${$this.key}?vframe/jpg/offset/1/w/800/h/450`;
                if ($this.thumb == "") {
                  $this.thumb = thumb;
                }
                $this.thumbs[0] = thumb;
              }
            });
        };

        var next = function (response) {
          var total = response.total;
          $this.$refs.progress.style.width = parseInt(total.percent) + "%";
          $this.$refs.proNumber.innerHTML = `${$this.$t("global.已上传")}${
            Math.round(total.percent * 100) / 100
          }%`;
        };

        var subObject = {
          next: next,
          error: error,
          complete: complete,
        };

        var config = {
          useCdnDomain: true,
          disableStatisticsReport: false,
          retryCount: 3,
          region: null,
        };
        var putExtra = {
          fname: $this.fileName.split(".")[0],
          params: {},
          mimeType: null,
        };
        this.$http.get("/api/common/upload/token/video").then((res) => {
          this.token = res.data;
          observable = qiniu.upload(
            e.target.files[0],
            Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
            this.token,
            putExtra,
            config
          );
          subscription = observable.subscribe(subObject);
        });
      }
    },
    upImg(e) {
      if (e.target.files[0].size / 1024 / 1024 > 3) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
        return;
      }
      let param = new FormData();
      param.append("files", e.target.files[0]);
      this.$http
        .post("/api/common/upload/image", param, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$message({
            message: response.message,
            type: "success",
          });
          switch (this.$store.state.imgIndex) {
            case 1:
              this.thumb = response.data;
              break;
            case 2:
              this.images.push(response.data);
              break;
          }
        });
    },
    getImgTwo() {
      this.$refs.bannerCropper.getCropData((data) => {
        this.bannerImgBase = data;
        this.stepForm.banner = data;
        this.bannerState = false;
        document.documentElement.style.overflowY = "scroll";
        this.fileUp = true;
      });
    },

    upImg1(e) {
      let $this = this;
      if (e.target.files[0].size / 1024 / 1024 > 3) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
        return;
      }
      var observable;
      var subscription;
      var error = function (err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function (res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        switch ($this.$store.state.imgIndex) {
          case 1:
            $this.thumb = res.key;
            break;
          case 2:
            $this.images.push(res.key);
            break;
        }
      };

      var next = function (response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true,
      };
      var putExtra = {
        fname: e.target.files[0].name,
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/image/token").then((res) => {
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
      // let param = new FormData();
      // param.append("files", e.target.files[0]);
      // this.$http
      //   .post("/api/common/upload/image", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then((response) => {
      //     this.$message({
      //       message: response.message,
      //       type: "success",
      //     });
      //     switch (this.$store.state.imgIndex) {
      //       case 1:
      //         this.thumb = response.data;
      //         break;
      //       case 2:
      //         this.images.push(response.data);
      //         break;
      //     }
      //   });
    },

    getOtherCreator() {
      let config = {
        loading: false,
      };
      this.$http.get("/api/u/video/otherCreator", config).then((response) => {
        this.fanlist = response.data;
      });
    },
    testValue(envent, valueS) {
      let reg = /\S/;
      if (!this.key && !this.videoId) {
        this.$message.error(this.$t("global.请上传视频或选择已发布作品"));
        document.getElementById("nav").scrollIntoView(true);
        return false;
      }
      if (!this.title.replace(/[\r\n\s]/g, "")) {
        this.$message.error(this.$t("global.视频名称不能为空"));
        document.getElementById("view2").scrollIntoView(true);
        return false;
      }
      if (!this.enTitle.replace(/[\r\n\s]/g, "") && this.matchProperty == 1) {
        this.$message.error(this.$t("global.视频名称英文不能为空"));
        document.getElementById("view3").scrollIntoView(true);
        return false;
      }
      if (!this.isOriginal) {
        this.$message.error(this.$t("global.请选择是否原创"));
        return false;
      }
      if (!this.isPub && this.matchId == 1031) {
        this.$message.error(this.$t("video.请选择是否公开"));
        document.getElementById("view6").scrollIntoView(true);
        return false;
      }

      if (this.matchProperty == 1 && this.language === "zh") {
        if (!this.textTer) {
          if (!this.introduction.replace(/[\r\n\s]/g, "")) {
            this.$message.error(this.$t("global.视频简介不能为空"));
            document.getElementById("view4").scrollIntoView(true);
            return false;
          }
          if (!this.enIntroduction.replace(/[\r\n\s]/g, "")) {
            this.$message.error(this.$t("global.视频简介英文不能为空"));
            document.getElementById("view4").scrollIntoView(true);
            return false;
          }
        } else {
          if (!this.introductionText.replace(/[\r\n\s]/g, "")) {
            this.$message.error(this.$t("global.视频简介不能为空"));
            document.getElementById("view4").scrollIntoView(true);
            return false;
          }
          if (!this.enIntroductionText.replace(/[\r\n\s]/g, "")) {
            this.$message.error(this.$t("global.视频简介英文不能为空"));
            document.getElementById("view4").scrollIntoView(true);
            return false;
          }
        }
      } else {
        if (!this.textTer) {
          if (!this.introduction.replace(/[\r\n\s]/g, "")) {
            this.$message.error(this.$t("global.视频简介不能为空"));
            document.getElementById("view4").scrollIntoView(true);
            return false;
          }
        } else {
          if (!this.introductionText.replace(/[\r\n\s]/g, "")) {
            this.$message.error(this.$t("global.视频简介不能为空"));
            document.getElementById("view4").scrollIntoView(true);
            return false;
          }
        }
      }
      if (this.matchId == 1027 && this.textTer) {
        const reg = /[^\x00-\xff]/g;
        let len1 = this.introductionText && this.introductionText.length;
        if (reg.test(this.introductionText)) {
          len1 +=
            this.introductionText.match(reg) &&
            this.introductionText.match(reg).length;
        }
        const roleLen1 = Math.ceil(len1 / 2);
        if (roleLen1 < 50 || roleLen1 > 500) {
          this.$message.error(this.$t("works.字数限制50-500字"));
          return false;
        }
      }
      if (
        (!this.images && this.imageCount) ||
        this.images.length < this.imageCount
      ) {
        this.$message.error(
          `${this.$t("global.请上传作品图片")},${this.$t("global.至少上传")}${
            this.imageCount
          }${this.$t("global.张")}`
        );
        document.getElementById("view5").scrollIntoView(true);
        return false;
      }
      if (!this.thumb) {
        this.$message.error(this.$t("global.请上传作品封面"));
        return false;
      }
      // if (this.industryIds.length === 0) {
      //   this.$message.error(this.$t("global.请选择行业"));
      //   return false;
      // }
      // if (this.professionIds.length === 0) {
      //   this.$message.error(this.$t("global.请选择专业"));
      //   return false;
      // }
    },
    submit() {
      let testResult = this.testValue();
      if (testResult === false) return;
      let url = "/api/u/video/create2";
      if (this.videoId) {
        url = "/api/u/video/update2";
      }
      let industryObj = this.$jsonUtils.getListExitsVal(
        this.industryIds,
        "_other"
      );
      let professionObj = this.$jsonUtils.getListExitsVal(
        this.professionIds,
        "_other"
      );
      const $this = this;
      let params = {
        // videoIntroduction: this.tinymceHtml,
        creatorIds: this.otherCreaterArr.map((item) =>
          item.creatorId.toString()
        ),
        creatorJson: JSON.stringify(this.otherCreaterArr),
        videoId: this.videoId,
        title: this.title,
        enTitle: this.enTitle,
        enIntroduction: this.enIntroduction,
        introduction: this.introduction,
        introductionText: this.introductionText,
        enIntroductionText: this.enIntroductionText,
        thumb: this.thumb,
        images: this.images.join(),
        isOriginal: this.isOriginal,
        isPub: this.isPub,
        equipment: this.equipment.join(),
        hash: this.hash,
        key: this.key,
        videoWidth: this.videoWidth,
        videoHeight: this.videoHeight,
        activityId: this.activityId,
        status: 1,
        industryIds: industryObj.notInList,
        professionIds: professionObj.notInList,
        fileName: this.fileName,
        editStatus: this.textTer ? 1 : 2,
        businessForm: this.videoBusinessDomain,
        videoTagGroup: this.videoTagFrontForms,
        thumbs: this.thumbs.join(),
        equipment: this.equipmentIds.join(),
        tags: this.hotIds.join(),
        otherIndustryIds: this.$jsonUtils.replaceAll(
          industryObj.inList.join(),
          "_other"
        ),
        otherProfessionIds: this.$jsonUtils.replaceAll(
          professionObj.inList.join(),
          "_other"
        ),
        allowDownload: this.allowDownload,
        matchCategoryIds: this.matchCategoryIds,
        source: "pc",
      };
      if (this.submitFlag) {
        this.submitFlag = false;
        this.$http
          .post(
            url,
            params,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            setTimeout(() => {
              this.submitFlag = true;
            }, 0);
            if (response.code === "OK") {
              if (this.matchId == 1031) {
                sessionStorage.setItem("videoInfo", JSON.stringify(params));
              }
              if (!$this.videoId) {
                $this.videoId = response.data;
              }
              this.$emit("callback", $this.videoId);
              //点击下一步回到上面
              this.$nextTick(() => {
                document.getElementById("nav").scrollIntoView(true);
              });
            }
          })
          .catch((err) => {
            setTimeout(() => {
              this.submitFlag = true;
            }, 0);
          });
      }
    },
    detail(id) {
      this.isFirst = false;
      setTimeout(() => {
        this.$refs.progress.style.width = "100%";
      }, 0);
      let $this = this;
      this.$http
        .get("/api/match/video/getMatchVideo", {
          params: { videoId: id, matchUrl: this.$route.params.contestName },
        })
        .then((response) => {
          if (response.data && response.code === "OK") {
            let data = response.data.videoDetailResponse;
            if (response.data.attachments) {
              this.attachments = JSON.parse(response.data.attachments);
              localStorage.setItem("attachments", JSON.stringify(this.attachments));
            }
            this.enTitle = data.enTitle || "";
            this.enIntroduction = data.enIntroduction || "";
            (this.introductionText = data.introductionText),
              (this.enIntroductionText = data.enIntroductionText),
              (this.hotIds = data.tagList);
            this.title = data.title;
            this.introduction = data.introduction;
            this.thumb = data.thumb;
            this.images = data.images != "" ? data.images.split(",") : [];
            this.allowDownload = data.allowDownload || 2;
            this.hash = data.hash;
            this.activityId = data.id;
            this.industryIds = data.industryIdList;
            this.professionIds = data.professionIdList;
            this.key = data.key;
            this.fileName = data.fileName;
            this.isPub = data.isPub;
            this.thumbs = data.thumbs != "" ? data.thumbs.split(",") : [];
            this.equipmentIds =
              data.equipment != "" ? data.equipment.split(",") : [];
            $this.isOriginal = String(data.isOriginal);
            if (data.editStatus == 1) {
              this.textTer = true;
            } else if (data.editStatus == 2) {
              this.textTer = false;
            }
            this.videoBusinessDomain = data.videoBusinessDomain;
            this.videoTagFrontForms = data.videoTagFrontForms;

            if (data.otherIndustryList != null) {
              for (var i = 0, n = data.otherIndustryList.length; i < n; i++) {
                let aa = data.otherIndustryList[i];
                aa["categoryId"] = aa.id + "_other";
                this.industryList.push(aa);
                $this.industryIds.push(aa.id + "_other");
              }
            }

            if (data.otherProfessionList != null) {
              for (var i = 0, n = data.otherProfessionList.length; i < n; i++) {
                let aa = data.otherProfessionList[i];
                aa["categoryId"] = aa.id + "_other";
                this.professionList.push(aa);
                $this.professionIds.push(aa.id + "_other");
              }
            }

            if (data.otherHotTagList != null) {
              for (var i = 0, n = data.otherHotTagList.length; i < n; i++) {
                let aa = data.otherHotTagList[i];
                this.hotTagList.push(aa);
                this.hotIds.push(aa.title);
              }
            }

            if (data.otherEquipmentList != null) {
              for (var i = 0, n = data.otherEquipmentList.length; i < n; i++) {
                let aa = data.otherEquipmentList[i];
                this.equipment.push(aa);
                this.equipmentIds.push(aa.title);
              }
            }
            const creatorJson =
              (data.creatorJson && JSON.parse(data.creatorJson)) || [];
            this.otherCreaterArr =
              data.creatorList.map((item, index) => {
                return {
                  ...creatorJson[index],
                  avatar: item.avatar,
                  nickname: item.nickName,
                };
              }) || [];
          }
        });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.contest-step2 {
  background: #F6F6F6;

  .videoupload {
    font-size: 12px;
    margin-bottom: 32px;
    color: rgba(153, 153, 153, 1);
    position: relative;
  }

  .contain {
    // display: flex;
    // flex-direction: row;

    .right {
      flex: 1;

      span {
        color: #999;
        font-size: 12px;
        display: block;
        line-height: 25px;
        margin-bottom: 10px;

        i {
          color: #E60012;
          margin-left: 10px;
        }

        b {
          color: #D0021B;
        }
      }

      &.female {
        span {
          line-height: 18px;

          b {
            color: #333;
          }
        }
      }
    }
  }

  .videoupload b {
    font-size: 20px;
    color: rgba(0, 0, 0, 1);
    margin-right: 8px;
  }

  .videoupload .resolving {
    position: absolute;
    color: #E60012;
    left: 150px;
    top: 30px;
  }

  .onloadings {
    position: relative;
    overflow: hidden;
  }

  .onloadings>div {
    position: absolute;
    top: 0;
    left: 55px;
    width: 608.59px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .onloadings .right {
    top: 15px;
  }

  .onloadings .videoed {
    display: inline-block;
    float: left;
    width: 35px;
    height: 46px;
    margin-right: 20px;
  }

  .onloadings .videoed img {
    float: left;
    width: 35px;
    height: 22px;
    margin-top: 22px;
  }

  .coverpic {
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
    margin-top: 32px;
  }

  .coverpic span {
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
    margin-right: 8px;
  }

  .required {
    position: relative;
    top: 3px;
    width: 10px;
    height: 12px;
    color: red;
    font-size: 18px;
    margin-right: 5px;
  }

  .randomtopic {
    overflow: hidden;
  }

  .randomtopic .onrandom {
    float: left;
    width: calc(100% - 188px);
    overflow: hidden;
  }

  .randomtopic .onrandom div {
    float: left;
    width: 116px;
    height: 67px;
    border-radius: 5px;
    margin-right: 10px;
    cursor: pointer;
    background-color: #f0f0f0;
    background-size: 100% 100%;
    box-sizing: border-box;
  }

  .dalayloading div.active {
    border: 2px solid #0579ff;
  }

  .randomtopic .onrandom .defaults {
    float: left;
    width: 100%;
    font-size: 12px;
    color: #999;
    margin: 20px 0 10px 0;
  }

  .containerSwcond {
    .basic-wrap {
      .uploadwidth {
        position: relative;
        float: left;
        width: 160px;
        height: 90px;
        padding: 0;
        cursor: pointer;
        margin: 20px 15px 0 0;
        background-size: 100% 100%;
        background-color: #F4F5F7;
        .add-wrap {
          width: 160px;
          height: 90px;
          margin: 0;
          border: none;

          .font {
            padding: 0;

            span {
              color: #fff;
              display: inline-block;
              margin: 0;
            }
          }
        }

        .font {
          padding: 0;

          span {
            color: #fff;
            display: inline-block;
            margin: 0;
          }
        }
      }

      .clickloads {
        margin: 0 15px 0 0;
      }
    }
  }

  .uploadwidth .font {
    position: relative;
    float: right;
    margin-top: -22px;
    width: 55px;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    border-radius: 3px;
  }

  .uploadwidth .font span:first-child {
    position: absolute;
    top: 0;
    width: 55px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    left: 0;
    z-index: 10;
  }

  .uploadwidth .font span:last-child {
    position: absolute;
    display: inline-block;
    width: 55px;
    height: 22px;
    line-height: 22px;
    top: 0;
    left: 0;
    z-index: 9;
    opacity: 0.6;
    border-radius: 3px;
    background-color: #000;
  }

  .dalayloading {
    position: relative;
    border-radius: 5px;
  }

  .dalayloading img {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 50%;
    left: 50%;
    margin: -12px 0 0 -12px;
  }

  .containtitle .font {
    color: #000;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 12px;
  }

  .containtitle .font .countNumber {
    font-size: 12px;
    font-weight: 400;
    color: #E60012;
  }

  .containtitle .usertype {
    width: 100%;
    height: 40px;
    padding: 0 70px 0 10px;
    border-radius: 5px;
    background-color: #f0f0f0;
    box-sizing: border-box;
  }

  .containtitle .textType {
    margin: 20px 0 17px 0;
    font-size: 0;
  }

  .containtitle .textType span {
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    display: inline-block;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    box-sizing: border-box;
    margin-right: 20px;
    cursor: pointer;
  }

  .containtitle .textType span.active {
    border: 2px solid rgba(32, 38, 204, 1);
    font-weight: 500;
    color: rgba(32, 38, 204, 1);
  }

  .containtitle .zhText, .enText {
    font-size: 14px;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    margin-bottom: 12px;
  }

  .containtitle .zhText img {
    width: 10px;
    height: 8px;
    margin-right: 5px;
  }

  .containtitle .enText img {
    width: 10px;
    height: 8px;
    margin-right: 5px;
  }

  .containtitle .imageText .activeImageText {
    margin: 17px 0;
  }

  .containtitle .imageText span {
    font-size: 14px;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    margin-right: 46px;
    cursor: pointer;
  }

  .containtitle .imageText span img {
    width: 10px;
    height: 8px;
    margin-right: 5px;
  }

  .containtitle .imageText span.imageTextActive {
    color: rgba(51, 51, 51, 1);
  }

  .real-name {
    position: relative;
  }

  .real-name span {
    position: absolute;
    top: 50%;
    right: 5px;
    color: #999;
    font-size: 12px;
    transform: translate(0, -50%);
  }

  em {
    font-style: normal;
  }

  #peopleDT {
    width: 100%;
    height: 200px;
    outline: none;
    border: 1px solid rgba(224, 224, 224, 1);
    box-sizing: border-box;
    margin-bottom: 25px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }

  .textareaname span {
    bottom: 20px;
    top: auto;
    right: 5px;
    transform: none;
  }

  .textareaname textarea {
    padding: 5px 0 0 10px;
  }

  input[type='radio'] + label::before {
    content: '\a0';
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    width: 17px;
    height: 17px;
    margin-right: 0.4em;
    border-radius: 50%;
    border: 1px solid rgba(151, 151, 151, 1);
    text-indent: 0.15em;
    line-height: 1;
    cursor: pointer;
    box-sizing: border-box;
  }

  input[type='radio']:checked + label::before {
    background-color: #027aff;
    background-clip: content-box;
    padding: 2px;
  }

  input[type='radio'] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
  }

  .female {
    position: relative;
    float: left;
    // width: 100px;
    line-height: 25px;

    label {
      margin-right: 10px;
    }
  }

  input::-webkit-input-placeholder {
    color: #999;
    text-align: right;
  }

  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #999;
    text-align: right;
  }

  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #999;
    text-align: right;
  }

  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #999;
    text-align: right;
  }

  .userinfortit input::-webkit-input-placeholder {
    text-align: left;
  }

  .userinfortit input::-moz-placeholder { /* Mozilla Firefox 19+ */
    text-align: left;
  }

  .userinfortit input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    text-align: left;
  }

  .userinfortit input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    text-align: left;
  }

  .phonenum input::-webkit-input-placeholder {
    text-align: left;
    font-size: 16px;
  }

  .phonenum input::-moz-placeholder { /* Mozilla Firefox 19+ */
    text-align: left;
    font-size: 16px;
  }

  .phonenum input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    text-align: left;
    font-size: 16px;
  }

  .phonenum input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    text-align: left;
    font-size: 16px;
  }

  .phonenum .el-input__inner::-webkit-input-placeholder {
    font-size: 12px;
  }

  .phonenum .el-input__inner::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 12px;
  }

  .phonenum .el-input__inner:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 12px;
  }

  .phonenum .el-input__inner:-ms-input-placeholder { /* Internet Explorer 10-11 */
    font-size: 12px;
  }

  .el-select-dropdown .el-select-dropdown__item {
    width: 250px;
  }

  .el-select-dropdown .el-select-dropdown__item .areacode {
    float: right;
  }

  .otherCreaterStyle {
    margin-top: 10px;
    position: relative;

    .drap {
      position: absolute;
      width: 150px;
      z-index: 1;
      background: rgba(0, 0, 0, 0);
    }

    .roleBox {
      position: relative;
      display: inline-block;

      .roleLen {
        position: absolute;
        right: 10px;
        top: 16px;
      }
    }

    .otherCitem {
      margin-top: 0.06rem;

      .fanHead {
        width: 30px;
        height: 30px;
        border-radius: 15px;
      }

      .nickname {
        font-size: 14px;
        display: inline-block;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
      }
    }

    .role {
      display: inline-block;
      width: 230px;
      margin-left: 10px;
    }

    span.deleteOC {
      border-radius: 0.06rem;
      cursor: pointer;
      color: #446EEB;
      font-size: 14px;
      display: inline-block;
    }
  }

  .otherCreaterStyle::-webkit-scrollbar {
    width: 6px;
    height: 16px;
  }

  .otherCreaterStyle::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  .otherCreaterStyle::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(210, 210, 210, 0.5);
  }

  .fanHead {
    width: 0.32rem;
    height: 0.32rem;
    margin: -0.02rem 0.1rem 0 0;
  }

  .upInput, .upInputIMG, .upInputIMG1 {
    display: none;
  }

  .containerSwcond {
    width: 100%;

    .operate-btn {
      width: 100%;
      padding: 0.8rem 0 0.8rem;
      justify-content: space-between;
      line-height: 0.46rem;
      text-align: center;
      font-size: 12px;
      color: #fff;
      background-color: #fff;

      .publish {
        display: inline-block;
        cursor: pointer;
        width: 121px;
        height: 40px;
        line-height: 40px;
        background: rgba(3, 161, 214, 1);
        border-radius: 3px;
        color: #ffffff;
        margin-right: 10px;
      }

      .review {
        display: inline-block;
        cursor: pointer;
        width: 121px;
        height: 40px;
        color: #999;
        line-height: 40px;
        border-radius: 3px;
        border: 1px solid rgba(204, 208, 215, 1);
        color: #999;
        margin-left: 10px;
      }
    }

    .radio-wrap {
      display: flex;
      margin-top: 0.36rem;

      .radio-head {
        color: #000000;
        font-size: 0.18rem;
      }

      .radio-cho {
        margin-top: 0.01rem;
      }
    }

    .moreMessage {
      /* height 5.64rem */
      padding: 0 3rem 0.8rem;
      margin-top: 0.2rem;
      /* overflow hidden */
      background-color: #ffffff;
    }

    .industry {
      margin-top: 0.3rem;
    }

    .choose-subject {
      // height 5.22rem
      padding: 0 3rem 0.6rem;
      margin-top: 0.2rem;
      overflow: hidden;
      background-color: #ffffff;

      .sub-head {
        color: #000000;
        font-size: 16px;
        padding-top: 0.3rem;
      }

      .tolabout {
        display: inline-block;
        float: left;
      }

      .sub-content {
        display: flex;
        flex-wrap: wrap;

        .sub-item {
          margin: 0.39rem 0.34rem 0 0;
          display: flex;

          .choose-item {
            width: 0.18rem;
            height: 0.18rem;
            background: url('/static/uploadvideo/chooseItem.png') no-repeat;
            background-size: 0.18rem 0.18rem;
          }

          .choose-con {
            font-size: 0.2rem;
            color: #000000;
            margin: -0.06rem 0 0 0.1rem;
          }
        }
      }
    }

    .hot-label {
      display: flex;
      color: #333333;
      font-size: 12px;

      .title {
        padding-top: 0.3rem;
      }
    }

    .choose-label {
      display: flex;
      flex-wrap: wrap;

      .label {
        margin: 0.2rem 0.2rem 0 0;
        display: flex;
        /* width 1.4rem */
        height: 0.4rem;
        line-height: 0.4rem;
        background-color: #f9f9f9;
        border-radius: 0.2rem;
        border: solid 1px #dddddd;
        color: #999999;
        font-size: 0.18rem;
        position: relative;
        justify-content: space-between;

        .font {
          /* width 1.05rem */
          padding: 0 0.18rem;
          text-align: center;
        }

        span {
          position: absolute;
          right: 0.35rem;
        }

        .close {
          width: 0.35rem;
        }

        img {
          display: block;
          width: 0.1rem;
          height: 0.1rem;
          margin: 0.15rem auto;
        }
      }
    }

    .fixcation {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.3;
      z-index: 999;
      background-color: #000;
    }

    .phoneCertification {
      position: fixed;
      z-index: 1000;
      top: 50%;
      left: 50%;
      width: 390px;
      height: 393px;
      border-radius: 5px;
      margin: -196.5px 0 0 -195px;
      background-color: #fff;
    }

    .phoneCertification .userphone {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-bottom: 1px solid #E9EAED;
      box-sizing: border-box;
    }

    .phoneCertification .areainfor {
      padding: 40px 48px 0;
    }

    .phoneCertification .areainfor p {
      color: #999;
      font-size: 14px;
      margin-bottom: 44px;
    }

    .phoneCertification .phonenum {
      overflow: hidden;
      border-bottom: 1px solid #E9EAED;
    }

    .tps29 {
      margin-top: 29px;
    }

    .onloadings .right span {
      float: right;
    }

    .phoneCertification .phonenum .leftside {
      position: relative;
      float: left;
      width: 76px;
      height: 50px;
      border: none;
      outline: none;
      font-size: 16px;
      appearance: none;
      -o-appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      background-color: #fff;
    }

    select::-ms-expand {
      display: none;
    }

    .phoneCertification .phonenum .usercode {
      line-height: 50px;
    }

    .phoneCertification .phonenum input {
      float: left;
      width: calc(100% - 76px);
      height: 50px;
      font-size: 16px;
      padding-left: 10px;
      box-sizing: border-box;
    }

    .phoneCertification .tps29 input {
      width: 150px;
    }

    .phoneCertification .tps29 .havecode {
      display: inline-block;
      float: left;
      font-size: 12px;
      height: 50px;
      line-height: 50px;
      color: #333;
      cursor: pointer;
    }

    .phoneCertification .tps29 .havecodehase {
      display: inline-block;
      float: left;
      font-size: 12px;
      height: 50px;
      line-height: 50px;
      color: #999;
      cursor: pointer;
    }

    .phoneCertification .submitbtns {
      display: block;
      width: 184px;
      height: 40px;
      margin: 44px auto 0;
      font-size: 14px;
      color: #fff;
      text-align: center;
      line-height: 40px;
      border-radius: 3px;
      cursor: pointer;
      background: rgba(3, 161, 214, 1);
    }

    .closepopus {
      position: absolute;
      width: 17px;
      height: 17px;
      top: 16px;
      right: 13px;
      cursor: pointer;
    }

    .addLabel {
      padding: 0 80px 20px;
      margin-top: 0.2rem;
      overflow: hidden;
      background-color: #ffffff;
      padding-bottom: 0.3rem;
    }

    .editTitles {
      width: 100%;
    }

    .stick {
      display: inline-block;
      margin-left: 0.3rem;
      width: 0.9rem;
      height: 0.3rem;
      background: #0060ff;
      color: #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 0.3rem;
      cursor: pointer;
    }

    .alHead {
      padding-top: 36px;
      font-size: 20px;
      color: #000;
      font-weight: bold;

      span {
        color: #999999;
        font-size: 12px;
      }
    }

    .upload {
      float: left;
      width: 160px;
      height: 90px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border-radius: 5px;
      margin: 0 10px 10px 0;
      position: relative;
    }
    .upload .deteleImg {
      position: absolute;
      width: 25px;
      height: 25px;
      right: -8px;
      top: -8px;
      cursor: pointer;
      display: none;
    }
    .upload:hover .deteleImg {
      display: block;
    }
    .clickloads {
      position: relative;
      float: left;
      margin-right: 0;
      background-color: #f3f3f3;
    }

    .clickloads img {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 31px;
      height: 29px;
      margin: -14.5px 0 0 -15.5px;
    }

    .clickloads .font {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 55px;
      height: 22px;
      line-height: 22px;
      color: #fff !important;
      font-size: 12px !important;
      border-radius: 3px;
    }

    .clickloads .add-wrap {
      border-radius: 5px;
      cursor: pointer;

      /* .add {
        display: block;
        width: 0.8rem;
        height: 0.8rem;
        margin: 0.55rem auto 0.1rem;
      } */
      .font {
        color: #333333;
        text-align: center;
        font-size: 0.22rem;
      }
    }

    .add-wrap-active {
      border: none;
    }

    .editTitles p {
      // margin-top: 30px;
    }

    .editTitles .font span {
      font-size: 12px;
      color: #999;
      margin-left: 8px;
    }

    .moretitle {
      overflow: hidden;
    }

    .moretitle span {
      display: inline-block;
      float: left;
      font-size: 14px;
      color: #999;
      height: 32px;
      cursor: pointer;
      line-height: 32px;
      padding: 0 12px;
      border-radius: 16px;
      cursor: pointer;
      margin: 0 10px 10px 0;
      border: 1px solid rgba(204, 208, 215, 1);
      box-sizing: border-box;
    }

    .moretitle .active {
      color: #0079FF;
      height: 32px;
      border: 1px solid #0079FF;
      box-sizing: border-box;
    }

    .clickaddtitle {
      display: inline-block;
      float: left;
      width: 70px;
      height: 32px;
      cursor: pointer;
      text-align: center;
      color: #999;
      margin: 0 10px 10px 0;
      border-radius: 16px;
      line-height: 32px;
      font-size: 14px;
      border: 1px solid rgba(204, 208, 215, 1);
      background: rgba(243, 243, 243, 1);
    }

    .userinfortit {
      position: relative;
      float: left;
      width: 150px;
      height: 32px;
    }

    .userinfortit input {
      float: left;
      width: 100px;
      height: 32px;
      font-size: 14px;
      padding-left: 10px;
      background-color: #f3f3f3;
      border-radius: 16px 0 0 16px;
      box-sizing: border-box;
    }

    .userinfortit a {
      float: left;
      width: 50px;
      height: 32px;
      color: #fff;
      cursor: pointer;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      border-radius: 0 16px 16px 0;
      background-color: #4A90E2;
    }
    #view5{
      padding-top: 106px;
    }
    #view6{
      padding-top: 106px;
    }
    .upload-wrap {
      /* height 6.32rem */
      /* overflow hidden */
      padding-top: 40px;
      background-color: #ffffff;

      .up-head {
        color: #000000;
        font-size: 16px;

        span {
          color: #999999;
          font-size: 12px;
        }
      }

      .bline {
        width: 100%;
        height: 0.02rem;
        background: #dcdfe6;
        margin-top: 0.3rem;
      }

      .upcontent {
        overflow: hidden;
      }

      .modify-btn {
        width: 1.55rem;
        height: 0.46rem;
        margin: 0.3rem 0.86rem 0;
        line-height: 0.46rem;
        font-size: 0.18rem;
        text-align: center;
        color: #0161ff;
        cursor: pointer;
        border-radius: 0.23rem;
        border: solid 1px #0161ff;
      }
    }

    .basic-wrap {
      padding: 0 80px 20px;
      margin-top: 0.2rem;
      background-color: #ffffff;
    }

    .contain {
      padding: 78px 0 12px 0;
      margin-top: -66px;
      select {
        width: 4.5rem;
        height: 0.5rem;
        margin-top: 0.1rem;
        background-color: #F9F9F9;
        border-radius: 0.08rem;
        text-indent: 0.1rem;
        outline: none;
        border: none;
        font-size: 0.18rem;
      }

      .special {
        display: flex;
        justify-content: space-between;
      }

      #area {
        display: block;
        width: 1.22rem;
      }

      .city {
        display: block;
        width: 3.08rem;
        margin-left: 0.2rem;
      }

      .resetW {
        width: 14.79rem;
      }
    }

    .progress-wrap {
      overflow: hidden;
      padding: 0 80px;
      background-color: #ffffff;

      .progress-head {
        margin-top: 25px;
        padding-bottom: 20px;
        justify-content: space-between;
        .uploadVideo {
          padding: 8px 25px;
          background: #3664ed;
          font-size: 16px;
          color: #fff;
          border-radius: 4px;
          line-height: 24px;
          cursor: pointer;

          &.has {
            float: right;
          }
        }

        .left {
          font-size: 14px;
          color: rgba(0, 0, 0, 1);
          font-weight: bold;
        }

        .right {
          font-size: 14px;
          margin-top: 8px;
          color: rgba(153, 153, 153, 1);

          span {
            display: inline-block;
            margin-left: 0.3rem;
          }
        }
      }

          .inputBox {
      margin-bottom: 30px;

      .titleInput {
        // height: 22px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 22px;
        margin-bottom: 12px;

        span {
          font-size: 14px;
          font-weight: 400;
          color: #B8B8B8;
          margin-left: 10px;
        }
      }

      .address_input1 {
        width: 285px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #E0E0E0;
        padding-left: 15px;
      }

      .address_input2 {
        width: 730px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #E0E0E0;
        padding-left: 15px;
      }

      .enclosure {
        .sureList {
          padding: 0 10px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #999999;
          font-size: 14px;
          font-weight: 500;
          color: #B8B8B8;
          cursor: pointer;
          float: left;
          margin-right: 10px;
          margin-bottom: 10px;
          position: relative;

          img {
            position: absolute;
            width: 25px;
            height: 25px;
            right: -8px;
            top: -8px;
            cursor: pointer;
            display: none;
          }

          &:hover {
            img {
              display: block;
            }
          }
        }

        .uploadSure {
          width: 144px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #999999;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          cursor: pointer;
          float: left;
        }
      }
    }
      .progress {
        position: relative;
        height: 5px;
        margin: 55px 0 30px 0;
        background: rgba(216, 216, 216, 1);
        border-radius: 3px;
      }

      .p-top {
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 5px;
        background: rgba(2, 122, 255, 1);
        border-radius: 3px;
      }
    }
  }

  .no-identificaton {
    padding: 1.2rem 0;

    .help-top {
      color: #000000;
      font-size: 0.26rem;
      text-align: center;
      margin: 1rem auto 0;
    }

    .top-choose {
      display: flex;
      justify-content: center;
      margin-top: 0.3rem;
      font-size: 12px;
      color: #333333;

      span {
        display: block;
        margin: 0 0.32rem;
      }
    }

    .Protocol {
      width: 5.78rem;
      display: flex;
      margin: 1rem auto 0;
      color: #707070;
      font-size: 12px;

      img {
        width: 0.19rem;
        height: 0.19rem;
        margin: 0.02rem 0.08rem 0 0.22rem;
      }
    }

    .support {
      width: 5.78rem;
      margin: 0.6rem auto 0;
      line-height: 0.32rem;
      text-align: center;
      color: #333333;
      font-size: 12px;
    }

    .tip {
      color: #ff0000;
      font-size: 12px;
      margin-top: 0.3rem;
      text-align: center;
    }

    .upload-button {
      display: block;
      cursor: pointer;
      width: 3.8rem;
      height: 0.6rem;
      line-height: 0.6rem;
      color: #ffffff;
      font-size: 0.26rem;
      text-align: center;
      margin: 0 auto;
      background-color: #0161ff;
      border-radius: 0.08rem;
    }

    .disable-button {
      background-color: #5a5a5a;
      cursor: not-allowed;
    }
  }

  .hmessage {
    color: #409EFF;
    cursor: pointer;
  }

  .havecidehase {
    display: inline-block;
    width: 68px;
    height: 50px;
    color: #999;
    line-height: 50px;
    white-space: nowrap;
  }

  .reUpload {
    position: absolute;
    top: 22px;
    right: 0;
    color: #fff;
    font-size: 13px;
    padding: 3px 7px;
    border-radius: 3px;
    cursor: pointer;
    background-color: #027aff;
  }
}
</style>
<style lang="stylus">
.fileUpload{
  border: none;
  background: transparent;
}
.watermark_sample {
  width: 960px;
  height: 540px;

  video {
    width: 100%;
    border-radius: 10px;
  }
}

.show_watermark_sample {
  color: #3664ED;
}

.contest-step2 {
  .upVideo .el-input__inner {
    width: 227px;
    height: 0.5rem;
    margin-top: 0.1rem;
    background-color: #f3f3f3;
    border-radius: 5px;
    text-indent: 0.1rem;
    outline: none;
    border: none;
    border: 1px solid rgba(204, 208, 215, 1);
    background: url('/static/uploadvideo/selarrorw.png') no-repeat 95% center;
    background-size: 13px 6px;
  }

  .upVideo .role .el-input__inner {
    background: none;
  }

  .upVideo .drap .el-tree-node {
    height: 50px;
    line-height: 50px;
    background: rgba(0, 0, 0, 0);
    cursor: pointer;
  }

  .upVideo .drap .el-tree-node .el-tree-node__content {
    line-height: 60px;
    display: inline-block;
  }

  .upVideo .drap .el-tree-node .el-tree-node__content:hover {
    background: none;
  }

  .upVideo .drap .el-tree-node .el-tree-node__content .el-tree-node__expand-icon {
    display: none;
  }

  .phonenum .el-input--suffix {
    float: left;
    height: 50px;
  }

  .phonenum .leftside .el-input__inner {
    width: 76px;
    padding: 0 5px 0 0;
    border: none;
    outline: none;
    margin-top: 0;
    height: 50px;
    line-height: 50px;
    text-indent: 0;
    font-size: 16px;
    cursor: text;
  }

  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #cecece;
  }

  input:-moz-placeholder, textarea:-moz-placeholder {
    color: #cecece;
  }

  input::-moz-placeholder, textarea::-moz-placeholder {
    color: #cecece;
  }

  input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    color: #cecece;
  }

  .el-checkbox {
    min-width: 1.5rem;
    margin-right: 0.4rem;
  }

  .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
}

.step2-fanHead {
  width: 30px;
  height: 30px;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/match/contestEnterStep/step2.vue